<template>
  <div class="container">
    <div class="panal mt-20">
      <div class="panal-header">Search Result</div>
      <div class="panal-body">
        <h5> Description</h5>
        <p> <strong>  Address :</strong> {{UserData.ObjectBasicData.GovernorateNameEN}} - {{UserData.ObjectBasicData.Address}} </p>

        <div class="divider"></div>
        <b-form>
        <div class="row">
        <div  class="col-12 col-md-6 mb-1">
          

<b-form-group id="input-group-1" label="Your Name:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="UserData.ObjectBasicData.Name"
          placeholder="Amr Ahmed"
          required 
          class="form-control su-border"
          disabled
          
        ></b-form-input>
 </b-form-group>


        </div>
        <div  class="col-12 col-md-6 mb-1">
<b-form-group id="input-group-2" label="Your Phone:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="UserData.ObjectBasicData.Phones"
          placeholder="01002410000"
          type="number"
        
          required 
          disabled
          class=" su-border form-control"
        ></b-form-input>
      </b-form-group>
        </div>
         <div  class="col-12 col-md-6 mb-1">
      
      
        <b-form-group
        id="input-group-4"
        label="Email address:"
        label-for="input-4"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="input-4"
          v-model="UserData.ObjectBasicData.Emails"
          type="email"
          placeholder="hh@yahoo.com"
          required class="form-control su-border"
          disabled
          
        ></b-form-input>
      </b-form-group>
      
      
      
      </div>
           <div  class="col-12 col-md-6 mb-1">
     <b-form-group id="input-group-3" label="NationalID:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="UserData.ObjectBasicData.nationalId"
          placeholder="01002410301234"
          type="number"
          required class="form-control su-border"
          disabled
        ></b-form-input>
      </b-form-group>
        
        </div>

           <div  class="col-12 col-md-6 mb-1">

       
       

        <b-form-group id="input-group-5" label="BirthDate:" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="UserData.ObjectBasicData.BirthDate"
          placeholder="10-12-1985"
          type="text"
          required class="form-control su-border"
          disabled
        ></b-form-input>
      </b-form-group>
        
        </div>


          <div  class="col-12 col-md-6 mb-1">
  
         <b-form-group id="input-group-6" label="Current School:" label-for="input-6">
        <b-form-input
          id="input-6"
          v-model="UserData.ObjectBasicData.CurrentSchool"
          placeholder="Ahmed lotfy"
          required 
          disabled
          class="form-control su-border"
        ></b-form-input>
 </b-form-group>
        
        </div>


      <div  class="col-12 col-md-6 mb-1">


<b-form-group id="input-group-7" label="High school certiﬁcate Group:" label-for="input-7">

   <b-form-input
          id="input-7"
          v-model="UserData.ObjectBasicData.CertificationGroupNameEN"
          placeholder="egypt"
          required 
          disabled
          class="form-control su-border"
        ></b-form-input>
    
      </b-form-group>


        
        </div>

        <div  class="col-12 col-md-6 mb-1">
    
         <b-form-group id="input-group-8" label="High school certiﬁcate :" label-for="input-8">
       <b-form-input
          id="input-8"
          v-model="UserData.ObjectBasicData.HighSchoolCertificateID"
          placeholder="A+"
          required 
          disabled
          class="form-control su-border"
        ></b-form-input>
      </b-form-group>
        

      </div>

<!-- <div  class="col-12 col-md-6 mb-1">
   <label>Employee impression
</label><br/>

      <b-form-textarea
      id="textarea"
      v-model="text"
      placeholder="Student Need call him Back"
      rows="3"
      max-rows="6"
      disabled
    ></b-form-textarea>
 </div> -->
  


 <div  class="col-12 col-md-6 mb-1">
   <label>Faculties interested in</label><br/>

<!-- v-model="UserData.FacultyList.FacultyName" -->
       <p   name="Faculties" 
            v-for="fac in UserData.FacultyList" :key="fac.FacultyID"  :value="fac.FacultyID"  class="col-12">
            <b-icon icon="check-circle-fill" variant="primary"></b-icon> {{fac.FacultyName}} 
        </p>
 </div>

 
    <!-- <div  class="col-12 col-md-3 mb-1">
          

<b-form-group id="input-group-12" label="Discount:" label-for="input-12">
        <b-form-input
          id="input-12"
          v-model="form.name"
          placeholder="20%"
          required 
          class="form-control su-border"
          disabled
          
        ></b-form-input>
 </b-form-group>


        </div> -->

        <!-- Start -->
<b-form-group class="col-md-6" id="input-group-13" v-slot="{ ariaDescribedby }">
    <b-form-checkbox-group v-model="form.checkedDiscount" id="checkboxes-13" :aria-describedby="ariaDescribedby">
      <div class="row mb-3">
      <div class="col-md-2"></div>

        <div class="col-md-12">
          <div class="border">
              <div class="title"> Discounts  
          </div>
            
            <div class="row p-2">
              <div class="col-md-12">
                <!-- v-model="UserData.DiscountList.DiscountName" -->
                <p   name="Discounts" 
                      v-for="dis in UserData.DiscountList" :key="dis.Serial"  :value="dis.DiscountID"  class="col-12">
                      <b-icon icon="check-circle-fill" variant="primary"></b-icon> {{dis.DiscountName}} on Event <strong>{{dis.MarketingEvent}}</strong> 
                </p> 

              </div>
              
            </div>

          </div>
      </div>

    </div>

    </b-form-checkbox-group>
</b-form-group>
        <!-- End -->
    <div  class="col-md-6 col-md-3 ml-2 mt-4 border p-2">
      <input type="checkbox" value="me" checked="ckecked" class="mr-1"/>Contact again
    </div>

 
 <!--  -->
<!-- Button trigger modal -->
<div class="text-center col-12 mt-4">
              <!-- <b-button type="submit" variant="primary">Update</b-button> -->
    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
       Update
    </button>
</div>

<!-- Modal -->
<div class="modalClass">
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">UPdate Faculities and discounts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>Faculties interested in </h5>
 <b-form @submit="onSubmit"  v-if="show" >

     <b-form-group id="input-group-11" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
         v-model="OldFaculties"
          id="checkboxes-11"
          :aria-describedby="ariaDescribedby"
        >
     <div class="row mb-3">
<div class="col-md-2"></div>


<div class="col-md-4" v-for="camp in campFac" :key="camp.BranchSerial">
<div class="border">
    <div class="title">{{camp.BrancheNameEN}} Branch 
</div>
  
<div class="row p-2">
<div class="col-md-12">

 <b-form-checkbox   v-for="f in camp.faculties" :key="f.BranchId" :value="f.FacultyBranchID" class="col-12" @change="FacultiesInsert(f.FacultyBranchID)"> {{f.FacultyNameEN}}</b-form-checkbox> 

   </div>
   
</div>

</div>
</div>


</div>


</b-form-checkbox-group>
      </b-form-group>

<div class="">

<b-form-group id="input-group-12" v-slot="{ ariaDescribedby }">
    <b-form-checkbox-group v-model="oldDiscounts" id="checkboxes-12" :aria-describedby="ariaDescribedby">
      <div class="row mb-3">
      <div class="col-md-2"></div>

        <div class="col-md-4">
          <div class="border">
              <div class="title"> Discounts  
          </div>
            
            <div class="row p-2">
              <div class="col-md-12">
                <b-form-checkbox   name="Discounts" 
                      v-for="dis in Discounts" :key="dis.Serial"  :value="dis.DiscountID" @change="AddDiscountToInquiry(dis.DiscountID)" class="col-12">
                      {{dis.NameEN}} 
                </b-form-checkbox> 

              </div>
              
            </div>

          </div>
      </div>

    </div>

    </b-form-checkbox-group>
</b-form-group>

</div>

 </b-form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="reloadeModal">Close</button>        
      </div>
    </div>
  </div>
</div>
</div>
<!--  -->
        </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '../../services/Event/event.services'

export default {
  name: "SearchResult",
  data() {
    return {
      text: '',
      UserData : '',
      Email: '',
form: {         
          name: '',
          phone: '',
           id: '',
           BirthDate:'',
           School:'',
           certiﬁcateG:'',
           certiﬁcate:'',
           checked: true,  
            checkedDiscount: [],
             Discounts: [],         
             Faculties: [],         
        },
  
        show: true,
         checked: true,
          checkedDiscount: [], 
           Discounts: [],
           Faculties: [], 
           campFac : [],   
           FacInsert: [],
DiscountToInquiry:[],
OldFaculties:[],
oldDiscounts: [],
fac : false     

    };
  },
  created(){
   this.UserData = JSON.parse(localStorage.getItem("NationalID"));  
  },

  computed: {

    currentUser(){
      return this.$store.state.auth.user.LoginInfo[0].UserID;
    },
    
  },
  // mounted(){
  //   EventService.BD_Faculties_Select(this.$route.params.id).then(result =>{
  //  if(Array.isArray(result.data)){
  //               this.SelectedFac = result.data
  //   this.SelectedFac.forEach(x=>{
  //     this.form.checked.push(x.FacultyID)
  //   })
  //            }else{
  //              this.SelectedFac = []
  //            }
  // })
  // },
     mounted(){
    EventService.SelectAllCampus().then(Response =>{
              this.campusData = Response.data;
                 this.campusData.forEach((campus,index)=> {
                 EventService.FacultyActiveByBranchAPI(campus.BranchSerial).then(result =>{
                   
                   this.campusData[index].faculties = result.data;
                   
                 })
                
            })

            }).finally(()=>{
             
             setTimeout(()=>{
           this.campFac =  this.campusData 
           this.UserData.FacultyList.forEach(fac =>{
             this.OldFaculties.push(fac.FacultyID)
           })
                 
           this.UserData.DiscountList.forEach(fac =>{
             this.oldDiscounts.push(fac.DiscountID)
           })
                  this.Loading = false ;
                   console.log("ca,p ",this.campFac)
             },2000)
            })


              EventService.IED_LookupDiscounts_SelectALL().then(Response =>{
               this.Discounts = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               //console.log('impression => ',this.Discounts)
           }, error => {
              this.empty = true;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

           
},


   methods: {
      onSubmit(event) {
        event.preventDefault()
        alert(JSON.stringify(this.form))
      },

  FacultiesInsert(serial){
//10                                                                                                   //10
          EventService.BD_Faculties_Insert(this.UserData.ObjectBasicData.BasicDataID,serial, this.currentUser ).then(Response =>{
             
               this.FacInsert= Response.data
               this.empty =false;            

                // eslint-disable-next-line no-console
                 //console.log('FacInsert => ', this.FacInsert)
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

      },
       AddDiscountToInquiry(DiscountID){
// this.$route.params.Serial
          EventService.AddDiscountToInquiry(DiscountID,this.UserData.ObjectBasicData.BasicDataID, this.currentUser  ).then(Response =>{
             
               this.DiscountToInquiry= Response.data
               this.empty =false
                 // eslint-disable-next-line no-console
                 console.log('DiscountToInquiry => ', this.DiscountToInquiry)
           }, error => {
             this.empty = true;
            
                 
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

      },

       handleBlur(){

          EventService.SelectBasicData(this.Email, this.NationalID).then(Response =>{
             
               this.SearchSelectBasicData= Response.data
               this.Discounts = this.SearchSelectBasicData.DiscountList
               this.empty =false;
             
                // eslint-disable-next-line no-console
               console.log('Search SelectBasicData Result => ',this.SearchSelectBasicData)
              
             //  alert("Done ");
            //   localStorage.setItem("NationalID", this.form.NationalID);
              // this.$router.push('/SearchResult');
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

      },

      reloadeModal()
      {               
          
        EventService.SelectBasicData(this.UserData.ObjectBasicData.Emails, this.UserData.ObjectBasicData.nationalId).then(Response =>{
             
             setTimeout(  this.SearchSelectBasicData= Response.data,3000)
             
               this.empty =false;
             
                // eslint-disable-next-line no-console
               console.log('Search Result => ',this.SearchSelectBasicData)
              
              //  alert("Done ");
              //  if(Response.data.length > 0)
              //  {
                 
              //  }
               localStorage.setItem("NationalID", JSON.stringify(this.SearchSelectBasicData));
               // JSON.parse(JSON.stringify(res.data))
               this.UserData = this.SearchSelectBasicData
             
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

             

  

      }

      
   }, 


};
</script>


<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  border: 1px solid #d2d2d2;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
.title{
    background: #285475;
    color: #fff;
    width: 200px;
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px;
    border-radius: 0px 0px 15px 15px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>